<template>
  <PageTemplate :title="parsedTitle" :loading="loading">
    <div class="mb-4" v-if="item.text" v-html="item.text"></div>
    <template v-if="parsedImgs.length">
      <v-alert
        class="mb-6 mx-auto"
        width="max-content"
        max-width="100%"
        color="grey"
        type="info"
      >
        Arraste a imagem para mudar de página
      </v-alert>
      <FlipBookWidget :items="parsedImgs"></FlipBookWidget>
    </template>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import FlipBookWidget from "../components/widgets/FlipBookWidget.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    item() {
      return this.$rest("magazines").item;
    },
    parsedTitle() {
      return this.item.title || this.$route.name;
    },
    parsedImgs() {
      if (!this.item.img) {
        return [];
      }

      return this.item.img.list.map(({ path }) => this.files + path);
    },
  },
  watch: {
    itemId() {
      this.$rest("magazines")
        .get({ id: this.itemId })
        .catch(() => this.$router.replace({ path: "/erro404" }));
    },
  },
  created() {
    this.$rest("magazines")
      .get({ id: this.itemId })
      .catch(() => this.$router.replace({ path: "/erro404" }))
      .finally(() => (this.loading = false));
  },
  components: {
    FlipBookWidget,
    PageTemplate,
  },
};
</script>
